import { Header, useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { SelectRadioGroup } from "@circle-react-uikit/SelectRadioGroup";

interface SectionsProps {
  onChangeSection: (
    section: string,
    setCurrentSection: (section: string) => void,
  ) => void;
}

export const Sections = ({ onChangeSection }: SectionsProps) => {
  const { sections, currentSection, setCurrentSection } = useCustomizeUIData();
  const radioOptions = sections.map(value => ({
    value,
    label: value,
  }));

  const handleSelectRadioOnChange = (section: string) => {
    onChangeSection(section, setCurrentSection);
  };

  return (
    <Header.Actions className="items-center justify-center">
      <SelectRadioGroup
        value={currentSection}
        onChange={handleSelectRadioOnChange}
        options={radioOptions}
      />
    </Header.Actions>
  );
};
